export const FAQContent = [
  {
    id: 1,
    questionName: "What information do your reports contain?",
    answerContent:
      "<p> ROOFTOP Measurement reports contain the pertinent information needed to complete a typical roof scope. All reports contain: </p><ul><li>Wire diagram of roof</li><li>Total square footage</li><li>Pitch identification</li></ul><p>The Standard report also includes linear measurements and the Comprehensive report includes area and pitch per facet</p>",
  },
  {
    id: 2,
    questionName: "What is your pricing structure?",
    answerContent:
      "<p>All of our report options are a low, flat rate. Other companies can make pricing so complicated with tiers and buy-in options. We believe pricing should be simple, easy, and predictable. We also offer additional savings when pre-ordering a 10 pack of reports.</p>",
  },
  {
    id: 3,
    questionName: "How quickly can I get a report?",
    answerContent:
      "<p>The typical turn-a-round is just one business day. However, should you find yourself in need of a report even quicker - RUSH delivery is always an option for just $15 and reports are usually available in just a matter of hours.</p>",
  },
  {
    id: 4,
    questionName: "How do these reports save me time and money?",
    answerContent:
      "<p>ROOFTOP Measurement reports streamline your site visits by eliminating the most time-consuming manual step - measuring the roof. With our reports you can spend more time with the customer, do more bids in less time, and sometimes avoid getting on the roof altogether.</p>",
  },
  {
    id: 5,
    questionName: "If I order a report, do I still need to visit the property?",
    answerContent:
      "<p>Yes. It is never recommended that an estimate, scope, or materials list be finalized without physical verification of the roof condition. Items such as roof penetrations, drains,scuppers, conduit, HVAC equipment, or underlayment must be accounted for in person. Furthermore, even though the images we use are the most recent, they may not show or depict a recent change to the construct of your project.</p>",
  },
];
